<template>
  <div class="jiesuan">
    <el-card class="middle-card">
      <div class="cgjiesuan">
        <firstHeading style="margin-bottom: 20px;">成果结算</firstHeading>
        <div class="info">
          <div class="box">总补贴金额（元）：<span>7,794</span></div>
        </div>
      </div>
      <div class="list">
        <firstHeading  style="margin-bottom: 20px;">终端用户响应情况</firstHeading>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
          fixed="right"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="num" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="终端用户名称" align="center">
          </el-table-column>
          <el-table-column prop="gddw" label="供电单位" align="center">
          </el-table-column>
          <el-table-column prop="bianhao" label="用户编号" align="center">
          </el-table-column>
          <el-table-column prop="speed" label="响应速度" align="center">
          </el-table-column>
          <el-table-column prop="fuhe" label="合同负荷(kW)" align="center">
          </el-table-column>
          <el-table-column prop="yewu" label="补贴金额(元)" align="center">
          </el-table-column>
          <el-table-column prop="beizhu" label="备注" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="2"
          layout="total, prev, pager, next, jumper"
          :total="tableData.length"
          background
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import firstHeading from "@/components/firstHeading.vue";
export default {
  name: "",
  components: {
    firstHeading,
  },
  data() {
    return {
      tableData: [
        {
          num: "1",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234242",
          speed: "日级",
          fuhe: "100",
          yewu: "123.00",
          beizhu: "",
        },
        {
          num: "2",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "123.00",
          beizhu: "",
        },
        {
          num: "3",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "拒绝参与",
          beizhu: "",
        },
        {
          num: "4",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "123.00",
          beizhu: "",
        },
        {
          num: "5",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "123.00",
          beizhu: "",
        },
        {
          num: "6",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "123.00",
          beizhu: "",
        },
        {
          num: "7",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "123.00",
          beizhu: "",
        },
        {
          num: "8",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "拒绝参与",
          beizhu: "",
        },
        {
          num: "9",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "拒绝参与",
          beizhu: "",
        },
        {
          num: "10",
          name: "终端用户1号",
          gddw: "南京",
          bianhao: "234236",
          speed: "日级",
          fuhe: "100",
          yewu: "123.00",
          beizhu: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.jiesuan {
  .middle-card {
    margin-bottom: 20px;
    .cgjiesuan{
      .info{
        width: 100%;
        height: 100px;
        background-image: linear-gradient(to right,  #f9fcfb, #e3f0ed,#f9fcfb);
        display: flex;
        align-items: center;
        .box{
          width: 50%;
          height: 100px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-left: 155px;
          >span{
            color: rgb(6,141,108);
            font-size: 28px;
            font-weight: 600;
          }
        }
      }
    }
    .list{
      margin-top: 75px;
    }
    .block {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    
  }
}
</style>
